import type { IconOrEmoji } from '@n8n/design-system/components/N8nIconPicker/types';

export const PROJECT_MOVE_RESOURCE_MODAL = 'projectMoveResourceModal';

export const DEFAULT_PROJECT_ICON: IconOrEmoji = { type: 'icon', value: 'layers' };
